import { render, staticRenderFns } from "./coupon_type_system.vue?vue&type=template&id=f4ef1866&"
import script from "./coupon_type_system.vue?vue&type=script&lang=js&"
export * from "./coupon_type_system.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports